// Add your custom JS here.

(function($) {

	$(document).ready(function(){

		$(window).scroll(function() {
			if ($(document).scrollTop() > 0) {
				$('#sticky-header').addClass('sticky-top');
			} else {
				$('#sticky-header').removeClass('sticky-top');
			}
		});

		/* $('.subkategorije').on('shown.bs.collapse', function () {
			var elementScrollTo = $(this).closest('.kategorije-collapse').find('.kategorija-img');

			$('html,body').animate({
				scrollTop: $(elementScrollTo).offset().top -125
			}, 100); 
		});  */
	});

	$('#carousel-izdvojeno').owlCarousel({
		items: 4, 
		loop: true, 
		margin: 30, 
		nav: false, 
		dots: true, 
		responsive: {
			0: {
				items: 1,
			},
			576: {
				items: 2,
			},
			992: {
				items: 3,
			},
			1200: {
				items: 4,
			},
		},
	});

	var owl = $('#carousel-izdvojeno');
	owl.owlCarousel();
	// Go to the next item
	$('.carouselnav-next').click(function() {
		owl.trigger('next.owl.carousel');
	});
	// Go to the previous item
	$('.carouselnav-prev').click(function() {
		owl.trigger('prev.owl.carousel');
	});


})(jQuery);